<template>
  <div class="lrPage">
    <div class="lrTop">
      <p>{{baseInfo.name || ''}}</p>
    </div>
    <div class="lrContainer">
      <div class="lrMainConent">
        <div class="lrContent">
          <div class="lrTitle">
            <strong>律师注册</strong>
            <span>
              已有账号？
              <router-link to="/login">登录</router-link>
            </span>
          </div>
          <template v-if="submitStatus">
            <div class="lrSuccess">
              <p>恭喜您成功提交注册申请，</p>
              <p>审核结果将会以邮件的形式发送给您。</p>
            </div>
          </template>
          <Form
            :label-width="140"
            :model="lawyerForm"
            :rules="lawyerFormValidate"
            ref="lawyerForm"
            style="margin: 25px;"
            v-else
          >
            <Row>
              <Col :md="12" :xs="24">
                <FormItem prop="lawyerMobile">
                  <template slot="label">
                    <Tooltip style="width: auto" transfer>
                      <div slot="content" style="white-space: normal;">请填写正确的手机号，此手机号将作为后续接收短信的地址！</div>手机号
                      <i class="fa fa fa-exclamation-circle"></i>
                    </Tooltip>
                  </template>
                  <Input placeholder="请输入手机号" type="text" v-model.trim="lawyerForm.lawyerMobile"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="姓名" prop="lawyerName">
                  <Input placeholder="请输入姓名" type="text" v-model="lawyerForm.lawyerName"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="email">
                  <template slot="label">
                    <Tooltip style="width: auto" transfer>
                      <div slot="content" style="white-space: normal;">请填写正确的邮箱，此邮箱将作为后续接收邮件的地址！</div>邮箱
                      <i class="fa fa fa-exclamation-circle"></i>
                    </Tooltip>
                  </template>
                  <Input placeholder="请输入邮箱" type="text" v-model.trim="lawyerForm.email"></Input>
                </FormItem>
              </Col>
              <Col :sm="12" :xs="24">
                <FormItem label="省市区" prop="areaCodes">
                  <Cascader
                    :data="regionData"
                    placeholder="省市区"
                    v-model.trim="lawyerForm.areaCodes"
                  ></Cascader>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="详细地址" prop="address">
                  <Input placeholder="请输入详细地址" type="text" v-model.trim="lawyerForm.address"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="个人简介" prop="remark">
                  <Input
                    :autosize="{minRows: 1,maxRows: 3}"
                    maxlength="255"
                    show-word-limit
                    type="textarea"
                    v-model.trim="lawyerForm.remark"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Divider />
              <Col :md="12" :xs="24">
                <FormItem
                  :rules="[{ required: true, validator: (rule, value, callback) => {
            this.$valideUtil.checkPaperCode('ID_CARD', value, callback, rule)
              }, trigger: 'blur' } ]"
                  label="身份证号"
                  prop="paperCode"
                >
                  <Input @on-blur="changePaperCode" maxlength="40" v-model="lawyerForm.paperCode" />
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="身份证照" prop="idCards">
                  <template v-if="idCardList.length>0">
                    <div :key="item.uid" class="agility-upload-list" v-for="item in idCardList">
                      <img :src="item.url" v-if="item.getFileType=='image'" />
                      <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                      <div class="agility-upload-list-cover">
                        <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                        <Icon @click.native="handleRemoveIDCards(item)" type="md-trash"></Icon>
                      </div>
                    </div>
                  </template>
                  <div class="agility-upload-list">
                    <agilityFileUpload
                      :opts="fileOptsIDCards"
                      @uploadFile="uploadIDCards"
                      ref="uploadIDCards"
                    >
                      <template slot="uploadContent">
                        <div
                          class="pointer"
                          style="width: 58px;height:58px;line-height: 58px;border: 1px dashed #ddd;text-align: center;"
                        >
                          <Icon size="20" type="ios-camera"></Icon>
                        </div>
                      </template>
                    </agilityFileUpload>
                  </div>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Divider />
              <Col :md="12" :xs="24">
                <FormItem label="执业证号" prop="licenseNumber">
                  <Input placeholder="请输入执业证号" type="text" v-model.trim="lawyerForm.licenseNumber"></Input>
                </FormItem>
              </Col>

              <Col :md="12" :xs="24">
                <FormItem label="律师执业证照" prop="lns">
                  <template v-if="lnList.length>0">
                    <div :key="item.uid" class="agility-upload-list" v-for="item in lnList">
                      <img :src="item.url" v-if="item.getFileType=='image'" />
                      <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                      <div class="agility-upload-list-cover">
                        <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                        <Icon @click.native="handleRemoveLn(item)" type="md-trash"></Icon>
                      </div>
                    </div>
                  </template>
                  <div class="agility-upload-list">
                    <agilityFileUpload :opts="fileOptsLn" @uploadFile="uploadLn" ref="uploadLn">
                      <template slot="uploadContent">
                        <div
                          class="pointer"
                          style="width: 58px;height:58px;line-height: 58px;border: 1px dashed #ddd;text-align: center;"
                        >
                          <Icon size="20" type="ios-camera"></Icon>
                        </div>
                      </template>
                    </agilityFileUpload>
                  </div>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="执业时间" prop="startWorkDate">
                  <DatePicker
                    @on-change="(val)=>{lawyerForm.startWorkDate = val}"
                    format="yyyy-MM-dd"
                    placeholder="请选择执业时间"
                    style="width: 100%"
                    type="date"
                    v-model="lawyerForm.startWorkDate"
                  ></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Divider />
              <Col :md="12" :xs="24">
                <FormItem label="资格证号" prop="qualificationCertificateNumber">
                  <Input
                    placeholder="请输入资格证号"
                    type="text"
                    v-model.trim="lawyerForm.qualificationCertificateNumber"
                  ></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem label="律师资格证照" prop="qcs">
                  <template v-if="qcList.length>0">
                    <div :key="item.uid" class="agility-upload-list" v-for="item in qcList">
                      <img :src="item.url" v-if="item.getFileType=='image'" />
                      <div :class="`fileIcon ${item.getFileType}Icon`" v-else />
                      <div class="agility-upload-list-cover">
                        <Icon @click.native="viewFile(item)" type="md-eye"></Icon>
                        <Icon @click.native="handleRemoveQc(item)" type="md-trash"></Icon>
                      </div>
                    </div>
                  </template>
                  <div class="agility-upload-list">
                    <agilityFileUpload :opts="fileOptsQc" @uploadFile="uploadQc" ref="uploadQc">
                      <template slot="uploadContent">
                        <div
                          class="pointer"
                          style="width: 58px;height:58px;line-height: 58px;border: 1px dashed #ddd;text-align: center;"
                        >
                          <Icon size="20" type="ios-camera"></Icon>
                        </div>
                      </template>
                    </agilityFileUpload>
                  </div>
                </FormItem>
              </Col>
            </Row>
            <Row justify="center" type="flex">
              <Divider />
              <Col :md="6" :xs="6">
                <Button @click="handleSubmit" long type="primary">提交</Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
    <div class="copyright">{{baseInfo.copyRight || ''}}</div>
    <Modal
      :title="'预览--'+ viewFileData.name"
      @on-cancel="()=>{this.showPreview= false}"
      fullscreen
      v-model="showPreview"
    >
      <filePreview :fileOption="viewFileData" v-if="showPreview"></filePreview>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'lawyerRegister',
  data () {
    const checkName = (rule, value, callback) => {
      let reg = /^[-_#."/()a-zA-z0-9\u4e00-\u9fa5]{1,50}$/
      if (value === undefined || value.trim() === "") {
        callback(new Error("名称不能为空"))
      } else if (!reg.test(value)) {
        callback(new Error("只支持英文大小、数字、中文及‘-_#.\"/()’的1-50位组合"))
      } else {
        callback()
      }
    }
    const checkQcs = (rule, value, callback) => {
      if (this.qcList === undefined || this.qcList.length === 0) {
        callback(new Error("律师资格证照不能为空"))
      } else {
        callback()
      }
    }
    const checkLns = (rule, value, callback) => {
      if (this.lnList === undefined || this.lnList.length === 0) {
        callback(new Error("律师执业证照不能为空"))
      } else {
        callback()
      }
    }
    const checkIdCards = (rule, value, callback) => {
      if (this.idCardList === undefined || this.idCardList.length === 0) {
        callback(new Error("身份证照不能为空"))
      } else {
        callback()
      }
    }
    return {
      baseInfo: {},
      regionData: [],
      lawyerFormValidate: {
        lawyerName: [{ required: true, validator: checkName, trigger: "blur" }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式错误', trigger: 'blur' }
        ],
        lawyerMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { type: 'string', pattern: /^1[3456789]\d{9}$/, message: '手机号格式有误', trigger: 'blur' }
        ],
        licenseNumber: [{ required: true, message: '请输入执业证号', trigger: "blur" }],
        qualificationCertificateNumber: [{ required: true, message: '请输入资格证号', trigger: "blur" }],
        startWorkDate: [{ required: true, message: '请选择执业时间', trigger: 'blur', pattern: /.+/ }],
        qcs: [{ required: true, type: 'array', validator: checkQcs, trigger: 'change' }],
        lns: [{ required: true, type: 'array', validator: checkLns, trigger: 'change' }],
        idCards: [{ required: true, type: 'array', validator: checkIdCards, trigger: 'change' }],
      },
      lawyerForm: {
        gender: '',// 性别
        paperType: 'ID_CARD',//证件类型
        paperCode: '', //证件编码
        areaCodes: [],
        birthday: null,//出生日期
        qualificationCertificateNumber: '',//资格证号
        licenseNumber: '',//执业证号
        startWorkDate: null,//执业时间
        address: '', //联系地址
        remark: '', //个人简介
        email: '',
        lawyerMobile: '',
        files: [],//附件
      },

      idCardList: [],
      qcList: [],
      lnList: [],
      showPreview: false,
      viewFileData: {},
      fileOptsIDCards: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      fileOptsQc: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      fileOptsLn: {
        multiple: true,
        format: ['jpg', 'jpeg', 'png',],
        showUploadList: false,
        defauleFiles: [],
        data: {
          catalogName: "LAWYER"
        },
      },
      avatarOpts: {
        multiple: false,
        format: ['jpg', 'jpeg', 'png'],
        showUploadList: false,
        defauleFiles: [],
        type: 'select',
        data: {
          catalogName: "avatar"
        },
      },
      submitStatus: false,
    }
  },
  methods: {
    changePaperCode: function () {
      if (this.lawyerForm.paperCode) {
        this.lawyerForm.birthday = this.$common.discriCard(this.lawyerForm.paperCode, 'birthday')
        this.lawyerForm.gender = this.$common.discriCard(this.lawyerForm.paperCode, 'gender')
      }
    },
    uploadIDCards: function (data) {
      let that = this
      this.idCardList = data
      if (this.idCardList.length > 0) {
        this.idCardList.forEach(function (obj) {
          obj['subject'] = 'ID_CARD'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveIDCards: function (file) {
      const infileList = this.$refs.uploadIDCards.fileList
      this.$refs.uploadIDCards.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('idCards')
    },
    uploadQc: function (data) {
      let that = this
      this.qcList = data
      if (this.qcList.length > 0) {
        this.qcList.forEach(function (obj) {
          obj['subject'] = 'LAWYER_QC'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveQc: function (file) {
      const infileList = this.$refs.uploadQc.fileList
      this.$refs.uploadQc.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('qcs')
    },
    uploadLn: function (data) {
      let that = this
      this.lnList = data
      if (this.lnList.length > 0) {
        this.lnList.forEach(function (obj) {
          obj['subject'] = 'LAWYER_LN'
          obj['getFileType'] = that.$common.getFileType(obj.fileType)
        })
      }
    },
    handleRemoveLn: function (file) {
      const infileList = this.$refs.uploadLn.fileList
      this.$refs.uploadLn.fileList.splice(infileList.indexOf(file), 1)
      this.$refs["lawyerForm"].validateField('lns')
    },
    viewFile (item, index) {
      this.viewFileData = Object.assign({}, item)
      this.viewFileData.filePath = item.url
      this.showPreview = true
    },
    reset () {
      this.$refs["lawyerForm"].resetFields()
    },
    handleSubmit: function () {
      let that = this
      this.$refs["lawyerForm"].validate(valid => {
        if (valid) {
          if (this.lawyerForm.birthday) {
            this.lawyerForm.birthday = this.$moment(this.lawyerForm.birthday).format('YYYY-MM-DD')
          }
          if (this.lawyerForm.startWorkDate) {
            this.lawyerForm.startWorkDate = this.$moment(this.lawyerForm.startWorkDate).format('YYYY-MM-DD')
          }
          that.lawyerForm.disabled = true
          const files = [...that.idCardList, ...that.qcList, ...that.lnList]
          that.$set(that.lawyerForm, 'files', files)
          that.$set(that.lawyerForm, 'lnImgs', that.lnList)
          that.$set(that.lawyerForm, 'qcImgs', that.qcList)
          that.$set(that.lawyerForm, 'idImgs', that.idCardList)
          let formData = {
            lawyerName: that.lawyerForm.lawyerName,
            lawyerMobile: that.lawyerForm.lawyerMobile,
            lawyerEmail: that.lawyerForm.email,
            lawyerInfo: that.lawyerForm
          }
          that.$axiosH5.post(that.$apis.lawyerManagerApi.lawyerRegister.submit, formData).then(res => {
            if (res.success) {
              that.$Message.success("操作成功！")
              that.submitStatus = true
              // that.reset()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error("操作失败！")
          })
        } else {
          return false
        }
      })
    },
    loadBaseInfo: function () {
      let that = this
      that.$axios.post('/loginInfo').then(res => {
        if (res.success) {
          let data = res.result || {}
          this.baseInfo = data.projectInfo || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log("loadBaseInfo err", err)
        // that.$Message.error('获取失败！');
      })
    },
    initTree: async function () {
      let that = this
      that.regionData = await this.$baseData.handleData(false, that.$apis.dictionaryManager.region.getLvTree, null) || []
      // this.$axios.post(that.$apis.dictionaryManager.region.getLvTree).then(res => {
      //   if (res.success) {
      //     that.regionData = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error('区域数据获取失败！')
      // }).then(val => {
      // })
    }
  },
  beforeMount () {
    this.loadBaseInfo()
    this.initTree()
  }
}
</script>
<style lang="less" scoped>
.lrPage {
  text-align: left;
  height: 100%;
  // overflow-y: auto;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;

  .lrTop {
    height: 64px;
    background: #2d8cf0;
    color: #ffffff;
    display: flex;
    align-items: center;
    padding-left: 10px;
    p {
      align-items: center;
      line-height: normal;
      font-weight: 700;
      font-style: normal;
      font-size: 1.4rem;
    }
  }

  .lrContainer {
    flex-grow: 1;
    overflow: hidden;
    .lrMainConent {
      margin: 0 auto;
      height: 100%;
      padding: 10px;
      overflow-y: auto;
    }

    .lrContent {
      width: 70%;
      margin: 0 auto;
      min-height: 100%;
      min-width: 300px;
      background-color: #ffffff;
      border: 1px solid #c7ced4;

      // padding: 20px;

      .lrTitle {
        font-size: 16px;
        background: #f7f7f7;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          display: flex;
          align-items: center;

          a {
            color: #4e6ef2;
            text-decoration: none;
          }
        }
      }
      .lrSuccess {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        p {
          font-size: 18px;
          margin: 5px 0;
        }

        p:first-child {
          font-weight: bold;
        }
      }
    }
  }

  .copyright {
    height: 32px;
    line-height: 32px;
    font-size: 0.8rem;
    text-align: center;
  }
}
</style>

<style scoped>
.agility-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  /* border: 1px solid transparent; */
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.agility-upload-list img {
  width: 100%;
  height: 100%;
}
.agility-upload-list .fileIcon {
  width: 100%;
  height: 100%;
}
.agility-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.agility-upload-list:hover .agility-upload-list-cover {
  display: block;
}
.agility-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
